import React, { useState } from 'react';
import SalaryPresenter from './SalaryPresenter';
import Shell from '../../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import DTOSalary from './DTOSalary';
import { useTranslation } from 'react-i18next';

interface empDetailProps {
  name: string;
  designation: string;
}
function SalaryController() {
  const { t, i18n } = useTranslation();

  const [, setEmpDetail] = useState<empDetailProps>({
    designation: '',
    name: '',
  });

  function callback(data: empDetailProps) {
    setEmpDetail({
      name: data.name,
      designation: data.designation,
    });
  }
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <DTOSalary setEmpNameDesignation={callback} />
        <SalaryPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default SalaryController;
